export default {
  "write_description": "",
  "add_attachment": "",
  "cant_send_empty_msg": "",
  "processing_attachments_wait": "",
  "processing": "",
  "already_have_profile_warning": "Do you already have an account? <br /> Log in here to link your photo and profile to the chat.",
  "email_address": "",
  "password": "",
  "no_connected_group_of_users": "",
  "send_pm": "",
  "invite_to_chatroom": "",
  "report_to_admin": "",
  "block": "",
  "kick_from_my_chatrooms": "",
  "view_profile": "",
  "leave_chat": "",
  "select_room_to_invite": "",
  "no_rooms_yet": "",
  "dismiss": "",
  "loading": "",
  "conversation_is_blocked": "",
  "conversation_blocked_by_me": "",
  "conversation_blocked_by_opponent": "",
  "unlock": "",
  "type_chatroom_name": "",
  "create_chatroom": "",
  "choose_chatroom_name": "",
  "chatroom_name_example": "",
  "cancel": "",
  "create": "",
  "search": "",
  "clear": "",
  "no_emoji_found": "",
  "chose_default_skin_tone": "",
  "search_results": "",
  "frequently_used": "",
  "smiles_and_ppl": "",
  "animals_and_nature": "",
  "food_and_drink": "",
  "activity": "",
  "travel_and_places": "",
  "objects": "",
  "symbols": "",
  "flags": "",
  "custom": "",
  "default_skin_ton": "",
  "light_skin_ton": "",
  "medium_light_skin_ton": "",
  "medium_skin_ton": "",
  "medium_dark_skin_ton": "",
  "dark_skin_ton": "",
  "type_your_msg_here": "",
  "too_long_text": "",
  "exit_chat": "",
  "main_logo": "",
  "notifications": "",
  "please_wait": "",
  "no_notifications": "",
  "you_have_been_invited": "",
  "invited_by": "",
  "close": "",
  "msg_cannot_be_empty": "",
  "provide_info_about_user": "",
  "report_details_example": "",
  "submit": "",
  "description_details": "",
  "recent_chats": "",
  "escorts": "",
  "agencies": "",
  "members": "",
  "chatrooms": "",
  "general_chat": "",
  "back_to_private_area": "Retour à l'espace privé",
  "options": "",
  "benelux_chat_list": "",
  "exit": "",
  "search_for_someone": "",
  "user_unlocked": "",
  "server_error": "",
  "profile_not_available_atm": "",
  "user_kicked_from_rooms": "",
  "no_rooms_to_kick_user": "",
  "user_blocked": "",
  "conversation_already_blocked": "",
  "invitation_sent": "",
  // ----------------------------------
  "sign_in": "Sign in",
  "user_disconnected": "User Disconnected",
}